module.exports = __webpack_public_path__ + "static/p07_borreguitoRLegBackLTop-1261d0cf6a0946d606d6767535459070.png";